/* eslint-disable angular/definedundefined */
angular.module('ecrd').factory('RecordQueriesService', [
    'CoreRecordQueries',
    'RecordsManagerService',
    'AccountManager',
    'StudyContext',
    function RecordQueriesService(
        CoreRecordQueries,
        RecordsManagerService,
        AccountManager,
        StudyContext
    ) {
        var publicAPI = {};
        // 1. Custom functions
        /**
         * Carga la información de las queries relacionadas con un registro/paciente
         *
         * @param  {Number} recordId  ID del registro
         *
         * @return {Promise}          Resultado
         */
        publicAPI.loadFromRecord = function(recordId, globalLoading) {
            return AccountManager.init()
                .then(function() {
                    if (StudyContext.canWithQueries('read')) {
                        return RecordsManagerService.getQueries(recordId, globalLoading)
                            .then(function(queries) {
                                return CoreRecordQueries.load(queries);
                            });
                    }
                });
        }

        // 2. Inherited public
        Object.getOwnPropertyNames(Object.getPrototypeOf(CoreRecordQueries)).filter(function(key) {
            if (typeof CoreRecordQueries[key] == 'function' && key != 'constructor' && key.indexOf('_') !== 0) {
                if (typeof publicAPI[key] != 'undefined') {
                    throw new Error('Function ' + key + ' is present in Core object');
                }
                publicAPI[key] = CoreRecordQueries[key].bind(CoreRecordQueries);
            }
        });

        return publicAPI;
    },
]);
